import React from 'react';
import { connect } from 'react-redux'; 
import SearchList from './search/SearchList';
import Sponsor from './search/Sponsor';
import PropTypes from 'prop-types';

const Result = ({ posts, error }) => {
    if (error) {
        return(
            <div id="SearchWeb" className="Section">
                <ul className="ListBlock" id="SiteSearchResult">
                    <h3>システムエラーです。</h3>
                    <p>申し訳ありません。少し時間をおいてお試しください。</p>
                </ul>
            </div>
        );
    } else if (posts.goo) {
        if (posts.goo.hit_num === '0') {
            return(
                <div id="SearchWeb" className="Section">
                    <ul className="ListBlock" id="SiteSearchResult">
                        <h3>検索結果がありません。</h3>
                    </ul>
                </div>
            );
        }
        
        return (
            <>
            <SearchList posts={posts.goo} />
            </>
        );

    } else {
        return '';
    }
}

// posts配列から最新データを取り出すための処理
const mapStateToProps = (state) => {

    if (state.posts) {
        const length = state.posts.length;
        const currentState = state.posts[length - 1];

        if (currentState.error){
            return{
                posts: currentState.items,
                error: true,
            }
        }
        return {
            posts: currentState.items,
        }
    }
}

Result.propTypes = {
    posts: PropTypes.shape({
        goo: PropTypes.object,
    }).isRequired,
    error: PropTypes.bool,
}

export default connect(mapStateToProps)(Result);
